import React, { Fragment } from "react"
import cn from "classnames"
import { Nav, Tab } from "react-bootstrap"
import Can from "../Can/Can"
import { TabEntry } from "../../types/tabEntry"
import { testId as defaultTestId } from "../../utility/tests/testId/common"
import styles from "./TabsBase.module.scss"

interface TabsBaseProps {
    id: string
    alwaysReload: boolean
    entries: TabEntry[]
    handleSelect: (key: string | null, e: React.SyntheticEvent<unknown>) => void
    activeKey: string
    invalidTabKeys?: string[]
    testId?: string
}

const TabsBase: React.FC<TabsBaseProps> = props => {
    const {
        id,
        alwaysReload,
        entries,
        invalidTabKeys,
        testId = defaultTestId.tabBaseLink,
        activeKey,
        handleSelect
    } = props

    const renderItem = (tab: TabEntry) => (
        <Nav.Item>
            <Nav.Link
                data-testid={testId}
                className={cn(styles.tab, invalidTabKeys?.includes(tab.key) && styles.tab_invalid)}
                eventKey={tab.key}
            >
                {tab.value}
                {Boolean(tab.counter) && <span className={styles.tab__counter}>{tab.counter}</span>}
            </Nav.Link>
        </Nav.Item>
    )

    return (
        <Tab.Container
            id={id}
            activeKey={activeKey}
            mountOnEnter={alwaysReload}
            unmountOnExit={alwaysReload}
            onSelect={handleSelect}
        >
            <div>
                <Nav className={styles.tabs}>
                    {entries.map(tab =>
                        tab.permission ? (
                            <Can key={tab.key} permission={tab.permission}>
                                {renderItem(tab)}
                            </Can>
                        ) : (
                            <Fragment key={tab.key}>{renderItem(tab)}</Fragment>
                        )
                    )}
                </Nav>
            </div>
            <Tab.Content className={styles.tabContent}>{props.children}</Tab.Content>
        </Tab.Container>
    )
}

export default TabsBase
